<template>
  <div>
    <el-card>
      <el-button type="primary" @click=" inception() " >新增</el-button>
    </el-card>
    <el-table :data="list" v-loading="loading">
      <el-table-column prop="id" label="ID" />
      <el-table-column prop="title" label="标题" />
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 'text'">
            {{ scope.row.content }}
          </span>
          <span v-if="scope.row.type === 'image'">
            <el-image
              style="width: 50px; height: 50px"
              :src="img_url + scope.row.content"
              fit="contain"
            />
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="mold" label="显示位置">
        <template slot-scope="scope">
          <span v-if="scope.row.mold === 'top'">轮博/滚动</span>
          <span v-if="scope.row.mold === 'bottom'">底部</span>
          <span v-if="scope.row.mold === 'center'">弹窗</span>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="开始时间" />
      <el-table-column prop="endTime" label="结束时间" />
      <el-table-column prop="is_active" label="是否启用">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.is_active" active-color="#13ce66" inactive-color="#ff4949" @change="isActive(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button> -->
          <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="limit"
      :total="total"
      @current-change="handlePageChange"
    />
    <el-dialog :visible.sync="dialogVisible" title="新增公告" width="600px">
      <el-form ref="form" :model="currentAnnouncement" label-width="120px">
        <el-form-item label="标题">
          <el-input v-model="currentAnnouncement.title" />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="currentAnnouncement.type" placeholder="请选择公告类型">
            <el-option label="文字" value="text" />
            <el-option label="图片" value="image" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="currentAnnouncement.type === 'image'" label="选择图片">
          <ImageSelector v-model="currentAnnouncement.imageId" />
        </el-form-item>
        <el-form-item v-if="currentAnnouncement.type === 'text'" label="内容">
          <el-input v-model="currentAnnouncement.content" type="textarea" />
        </el-form-item>
        <el-form-item label="显示位置">
          <el-select v-model="currentAnnouncement.mold" placeholder="请选择公告显示位置">
            <el-option label="轮播/滚动" value="top" />
            <el-option label="底部" value="bottom" />
            <el-option label="弹窗" value="center" />
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker v-model="currentAnnouncement.startTime" type="datetime" placeholder="选择开始时间" />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="currentAnnouncement.endTime" type="datetime" placeholder="选择结束时间" />
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch v-model="currentAnnouncement.enable" active-color="#13ce66" inactive-color="#ff4949" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getAnnouncements, createAnnouncement, updateAnnouncement, deleteAnnouncement} from '@/api/announcement'
import ImageSelector from '@/components/ImageSelector.vue'

export default {
  components: {
    ImageSelector
  },
  data() {
    return {
      list: [],
      page: 1,
      limit: 10,
      total: 0,
      dialogVisible: false,
      currentAnnouncement: {
        title: '',
        type: '',
        imageId: '',
        mold: '',
        startTime: '',
        endTime: '',
        enable: false,
        content: ''
      },
      loading: false,
      img_url: process.env.VUE_APP_MEDIA_URL || ''
    }
  },
  created() {
    this.handlePageChange(1)
  },
  methods: {
    inception() {
      this.dialogVisible = true
      this.currentAnnouncement = {
        title: '',
        type: '',
        imageId: '',
        mold: '',
        startTime: '',
        endTime: '',
        enable: false,
        content: ''
      }
    },
    isActive(row) {
      updateAnnouncement(row.id, { is_active: row.is_active }).then(() => {
        this.handleGetAnnouncements()
      })
    },
    handlePageChange(page) {
      this.page = page
      this.handleGetAnnouncements()
    },
    handleGetAnnouncements() {
      getAnnouncements(this.page, this.limit).then(response => {
        console.log(response)
        this.list = response.data.items
        this.total = response.data.total
      })
    },
    handleSave() {
      if (this.currentAnnouncement.id) {
        updateAnnouncement(this.currentAnnouncement).then(() => {
          this.handleGetAnnouncements()
          this.dialogVisible = false
        })
      } else {
        createAnnouncement(this.currentAnnouncement).then(() => {
          this.handleGetAnnouncements()
          this.dialogVisible = false
        })
      }
    },
    handleEdit(row) {
      this.currentAnnouncement = Object.assign({}, row)
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAnnouncement(row.id).then(() => {
          this.handleGetAnnouncements()
        })
      })
    }
  }
}
</script>

<style scoped>
.el-card {
  margin: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
